export const bull = '\u2022';
export const nbsp = '\u00A0';
